var componentRequireContext = require.context('components', true, /front\/line_form\/*/)
var ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)
